<template>
  <vs-popup fullscreen class="view-work-order-popup"
            :title="`VIEW WORK ORDER - ${orderDetails.work_order_code}`"
            @close="onClickClose()"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow >
      <div class="text-danger text-center font-bold text-2xl mb-8 mt-2" v-if=is_wo_disabled>
        This formulation is no longer approved for production and this WO cannot proceed. Please contact QC/Technical.
      </div>
      <div id="create-production-line-popup'" :class="{ disabled: is_wo_disabled }">
        <div style="white-space:nowrap; display:block;">
          <vs-button
            @click="printWorkOrder"
            color="warning"
            type="filled"
            icon-pack="feather"
            class="ml-2"
            style="display:inline-block;"
          >
            Print
          </vs-button>

          <vs-button
            @click="fetchQrData"
            color="primary"
            type="filled"
            icon-pack="feather"
            class="ml-2"
            style="display:inline-block;"
          >
            {{ is_qr_show ? 'Hide QR' : 'Show QR for Job' }}
          </vs-button>

          <span
            v-if="is_qr_show"
            style="background:#ffffff; margin-left:16px; display:inline-block; vertical-align:middle;"
          >
            <div style="background:#ffffff; padding:16px; display:inline-block;">
              <qrcode-vue
                :value="qr_data"
                :size="250"
                :margin="0"
                style="display:block; background:#ffffff;"
                level="M"
              />
            </div>
          </span>
        </div>

        <div class="vx-row mb-3 mt-8" id="printSection">
          <div class="vx-col md:w-1/4 w-full md:mb-0">
            <h5 class="mb-4" style="color: #626262">WO Summary</h5>
            <div class="overflow-hidden sm:rounded-lg ">
              <div class="border-t border-gray-200">
                <dl>
                  <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-sm font-semibold text-gray-500">
                      Work order number
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {{orderDetails.work_order_code}}
                    </dd>
                  </div>
                  <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-sm font-semibold text-gray-500">
                      ITS product code
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {{orderDetails.formulation_code}}
                    </dd>
                  </div>
                  <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-sm font-semibold text-gray-500">
                      ITS product name
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {{orderDetails.formulation_name}}
                    </dd>
                  </div>
                  <!-- <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-sm font-semibold text-gray-500">
                      Required by
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2" v-if="!!orderDetails.required_by">
                      {{orderDetails.order_items.length > 0 ? orderDetails.required_by : 'STOCK'}}
                    </dd>
                  </div> -->
                  <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-sm font-semibold text-gray-500">
                      WO status
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {{ (orderDetails.status && orderDetails.status.name) || '' }}
                    </dd>
                  </div>
                  <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-sm font-semibold text-gray-500">
                      QC status
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {{orderDetails.q_c_status}}
                    </dd>
                  </div>
                  <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-sm font-semibold text-gray-500">
                      WO Type
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      {{orderDetails.formulation_type}}
                    </dd>
                  </div>
                  <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-sm font-semibold text-gray-500">
                      Pack Size (KG)
                    </dt>
                    <dd class="mt-0 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                      <vs-input v-on:input="onInputWorkOrderDetails" v-model="orderDetails.pack_size"
                                class=""/>
                    </dd>
                  </div>
                  <div v-if="orderDetails.order_items.length === 0" class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-sm font-semibold text-gray-500">
                      Manufacturing Quantity (Kg)
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0">
                      {{Number(orderDetails.unallocated_amount).toFixed(4)}}
                      <!-- <vs-button v-if="!isInOpenStatus" @click="onClickViewLabel({ quantity: orderDetails.unallocated_amount })" color="primary" type="filled" size="large" class="w-full py-5 px-10 font-bold text-1xl mt-2" style="text-align: center"> Print </vs-button> -->

                    </dd>
                    <dd>
                    </dd>
                  </div>
                </dl>
              </div>
            </div>

            <!-- <div class="vx-row mt-8" v-if="!isInOpenStatus && orderDetails.order_items.length === 0">
                <div class="vx-col w-full">
                  <h5 class="mb-4" style="color: #626262">FG Label</h5>
                      
                  <div class="vx-row w-full flex justify-between items-center p-4 fg-label-table-background">
                    <vs-button @click="onClickViewLabel({ quantity: orderDetails.unallocated_amount })"  color="primary" size="small" type="filled" icon-pack="feather" icon="icon-printer" class="text-1xl ml-3" style="display: inline-block">Print</vs-button>
                  </div>
                  <vs-table :hoverFlat="true"  noDataText="">
                    <template slot="thead">
                      <vs-th class="text-sm" width="50%">Product Order Code</vs-th>
                      <vs-th width="50%" class="hiddenSection text-sm" >ACTION</vs-th>
                    </template>
                    <template>
                      <vs-tr :key="index" v-for="(stock, index) in orderDetails.formulation_stock.filter((x) => !!x.product_order)">

                        <vs-td class="text-sm">
                          {{stock.product_order.product_order_code}}
                        </vs-td>

                        <vs-td class="hiddenSection text-sm">
                          <vs-button @click="onClickViewLabel({order_id: stock.product_order.id})" color="primary" size="small" type="filled" icon-pack="feather" icon="icon-printer" class="ml-2 text-1xl" style="display: inline-block">Print</vs-button>
                        </vs-td>

                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
            </div> -->

            <div class="vx-row mt-8" v-if="!isInOpenStatus">
              <div class="vx-col w-full">
                <h5 class="mb-4" style="color: #626262">FG Label(s)</h5>
                <vs-table :hoverFlat="true"  noDataText="">

                  <template slot="thead">
                    <vs-th class="text-sm" width="50%">Batch Code / SO Code</vs-th>
                    <vs-th width="50%" class="hiddenSection text-sm" >ACTION</vs-th>
                  </template>
                  <template>
                    <vs-tr :key="index" v-for="(tr, index) in orderDetails.formulation_stock">

                      <vs-td class="text-sm text-primary">
                        <span v-if="!!tr.product_order">{{ tr.product_order.product_order_code }}</span>
                        <span v-else>Unallocated</span>
                      </vs-td>

                      <vs-td class="hiddenSection text-sm">
                        <vs-button @click="onClickViewLabel(tr)" color="primary" size="small" type="filled" icon-pack="feather" icon="icon-printer" class="ml-2 text-1xl" style="display: inline-block">Print</vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>

            <div class="vx-row mt-8" v-if="orderDetails.created_rm_waste_items.length > 0">
              <div class="vx-col w-full">
                <h5 class="mb-4" style="color: #626262">RM Waste Items</h5>
                <vs-table :hoverFlat="true"  noDataText="">

                  <template slot="thead">
                    <vs-th>RM code</vs-th>
                    <vs-th>Quantity (KG)</vs-th>
                  </template>
                  <template>
                    <vs-tr :key="index" v-for="(tr, index) in orderDetails.created_rm_waste_items">

                      <vs-td>
                        {{tr.raw_material}}
                      </vs-td>

                      <vs-td>
                        {{tr.quantity}}
                      </vs-td>

                      <vs-td v-if="!isInOpenStatus">
                        <vs-button @click="onClickViewLabel(tr)" color="primary" size="small" type="filled" icon-pack="feather" icon="icon-printer" class="ml-2 text-xl" style="display: inline-block"></vs-button>
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>

            <div class="vx-row mt-8" v-if="orderDetails.order_items.length > 0">
              <div class="vx-col w-full">
                <h5 class="mb-4" style="color: #626262">Sales orders in this WO</h5>
                <vs-table :hoverFlat="true"  noDataText="" class="w-full">

                  <template slot="thead">
                    <vs-th class="text-sm" width="40%">Product Order Code</vs-th>
                    <vs-th class="text-sm" width=20%>Required By</vs-th>
                    <vs-th class="text-sm" width="40%">Selected Quantity (KG)</vs-th>
                  </template>
                  <template>
                    <vs-tr :key="index" v-for="(tr, index) in orderDetails.order_items">

                      <vs-td class="text-sm">
                        {{tr.order_code}}
                      </vs-td>

                      <vs-td>
                        {{ tr.required_by || 'N/A' }}
                      </vs-td>

                      <vs-td class="text-sm">
                        {{tr.quantity}}
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
            <div class="vx-row mt-8">
              <div class="vx-col w-full">
                <h5 class="mb-4" style="color: #626262">Sundry Items</h5>
                <vs-table :hoverFlat="true"  noDataText="">
                  <template slot="header">
                    <vs-button @click.stop="onClickUpdateSundryItems()" color="primary" type="border" icon-pack="feather" size="small" class="ml-auto mr-0 mt-2 mb-1 hiddenSection">Add/Update</vs-button>
                  </template>
                  <template slot="thead">
                    <vs-th width="65%">Batch Number</vs-th>
                    <vs-th width="35%">Quantity</vs-th>
                  </template>
                  <template>
                    <vs-tr :key="index" v-for="(tr, index) in orderDetails.sundry_items">

                      <vs-td>
                        {{tr.batch_no}}
                      </vs-td>

                      <vs-td>
                        {{tr.quantity}}
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
            <div class="vx-row mt-8">
              <div class="vx-col w-full">
                <h5 class="mb-4" style="color: #626262">CCP Items</h5>
                <vs-table :hoverFlat="true"  noDataText="">
                  <template slot="header">
                    <vs-button size="small" @click="onClickAddCcpItems()" class="ml-auto mr-0 mt-2 mb-2 hiddenSection" color="primary" type="border">{{isPackOffCompletedStatus ? 'View' : 'Add / Update'}}</vs-button>
                  </template>
                  <template slot="thead">
                    <vs-th>Name</vs-th>
                    <vs-th>User</vs-th>
                    <!-- <vs-th>Comment</vs-th> -->
                  </template>
                  <template>
                    <vs-tr :key="index" v-for="(tr, index) in orderDetails.ccp_items">

                      <vs-td>
                        {{tr.ccp_item.name}}
                      </vs-td>

                      <vs-td>
                        {{tr.responded_by && tr.responded_by.name ? tr.responded_by.name : '' }}
                      </vs-td>

                      <!-- <vs-td>
                        {{tr.comment}}
                      </vs-td> -->

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
            <div class="vx-row" v-if="(isPackOffCompletedStatus || isPackOffInProgressStatus || isMixCompletedStatus) && !isDilCodedFormulation">
              <div class="vx-col md:w-full w-full">

                  <h5 class="mb-2 mt-2" style="color: #626262">QC Tests</h5>
                  <!-- <span class="text-warning text-sm" v-if="!isTastePanelApproved">Create and Sign Off Taste Panel Before QC Test</span> -->

                  <vs-table
                    :data="qc_tests"
                    class="table-dark-inverted table-auto vs-con-loading__container">
                    <template slot="header">
                        <vs-button v-can="'create-edit-work-orders-qc-test'" size="small" @click="onClickCreateQcTest('create', null)" class="ml-auto mr-0 mt-2 mb-2 hiddenSection" color="primary" type="border">Create</vs-button>
                    </template>

                    <template slot="thead">
                      <vs-th width="15%" class="text-xs">DATE</vs-th>
                      <vs-th width="15%" class="text-xs">DONE BY</vs-th>
                      <vs-th width="10%" class="text-xs">NOTE</vs-th>
                      <vs-th width="10%" class="text-xs">STATUS</vs-th>
                      <vs-th width="10%" class="text-xs">ACTION</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td >
                          {{ __dateTimeFormatter(data[indextr].created_at) }}
                        </vs-td>

                        <vs-td :data="data[indextr].done_by">
                          {{ data[indextr].done_by }}
                        </vs-td>
                        <vs-td :data="data[indextr].notes">
                          {{ data[indextr].notes }}
                        </vs-td>
                        <vs-td :data="data[indextr].status">
                          {{ data[indextr].status }}
                        </vs-td>
                        <vs-td>
                          <div class="vx-row" v-can="'create-edit-work-orders-qc-test'">
                            <vx-tooltip class="ml-2" text="Update QC Test" position="left">
                              <vs-button @click.stop="onClickCreateQcTest('update', data[indextr])"
                                         color="warning" type="filled" icon-pack="feather" icon="icon-edit"></vs-button>
                            </vx-tooltip>
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>

              </div>
            </div>
            <div class="vx-row" v-if="(isPackOffCompletedStatus || isPackOffInProgressStatus || isMixCompletedStatus) && !isDilCodedFormulation">
              <div class="vx-col md:w-full w-full">

                  <h5 class="mb-2 mt-2" style="color: #626262">Taste Panel</h5>

                  

                  <vs-table
                    :data="orderDetails.tasting_groups"
                    class="table-dark-inverted table-auto vs-con-loading__container">
                    <template slot="header" v-if="!isTastePanelApproved">
                        <vs-button v-can="'create-edit-work-orders-qc-test'" size="small" @click="onClickCreateTastePanel" class="ml-auto mr-0 mt-2 mb-2" color="primary" type="border">Create</vs-button>
                    </template>
                    <template slot="thead">
                      <vs-th width="30%" class="text-xs">TASTE PANEL CODE</vs-th>
                      <vs-th width="25%" class="text-xs">CREATED BY</vs-th>
                      <vs-th width="20%" class="text-xs">SIGN OFF STATUS</vs-th>
                      <vs-th width="25%" class="text-xs">ACTION</vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                          {{ tr.code }}
                        </vs-td>
                        <vs-td>
                          {{ tr.created_by || ''}}
                        </vs-td>
                        <vs-td>
                          {{ getSignoffStatus(tr) }}
                        </vs-td>
                        <vs-td>
                          <vs-button @click.stop="onClickViewTastePanel(tr)" size="small" color="success" type="filled" icon-pack="feather" icon="icon-eye"></vs-button>
                        </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
              </div>
            </div>
            
            <!-- <div class="vx-row mt-6" >
              <div class="vx-col md:w-full w-full">

                  <h5 class="mb-2 mt-2" style="color: #626262">Taste Panel</h5>

                  <vs-table
                    :data="tastingFormList"
                    class="table-dark-inverted table-auto vs-con-loading__container">

                    <template slot="thead">
                      <vs-th width="15%" class="text-xs">DATE</vs-th>
                      <vs-th width="15%" class="text-xs">DONE BY</vs-th>
                      <vs-th width="10%" class="text-xs">STATUS</vs-th>
                      <vs-th width="10%" class="text-xs">ACTION</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td >
                          {{ __dateTimeFormatter(data[indextr].created_at) }}
                        </vs-td>

                        <vs-td :data="data[indextr].done_by">
                          {{ data[indextr].done_by.name }}
                        </vs-td>
                        <vs-td :data="data[indextr].status">
                          {{ data[indextr].status }}
                        </vs-td>
                        <vs-td>
                          <div class="vx-row" v-can="'create-edit-work-orders-qc-test'">
                            <vx-tooltip class="ml-2" text="view Taste Panel" position="left" v-can="'view-quality-control-tastings'">
                              <vs-button @click.stop="onClickViewTasteForm(data[indextr].id)"
                                         color="warning" type="filled" icon-pack="feather" icon="icon-eye"></vs-button>
                            </vx-tooltip>
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>

              </div>
            </div> -->
            <div class="vx-row mt-6" >
              <div class="vx-col md:w-full w-full">

                  <h5 class="mb-2 mt-2" style="color: #626262">Additional Tasks</h5>

                  <vs-table
                    :data="tasks"
                    stripe
                    class="table-dark-inverted table-auto vs-con-loading__container">

                    <template slot="thead">
                      <vs-th width="40%" class="text-xs">CODE/NAME</vs-th>
                      <vs-th width="20%" class="text-xs">START DATE</vs-th>
                      <vs-th width="20%" class="text-xs">STATUS</vs-th>
                      <vs-th width="20%" class="text-xs">ACTION</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].scheduled_task_schedule.code">
                          {{ data[indextr].scheduled_task_schedule.code }} <br/>
                          {{ data[indextr].scheduled_task_schedule.name }}
                        </vs-td>
                        <vs-td :data="data[indextr].started_at">
                          {{ data[indextr].started_at ? __dateTimeFormatterToDate(data[indextr].started_at) : 'N/A' }}
                        </vs-td>
                        <vs-td :data="data[indextr].status">
                          {{ data[indextr].status }}
                        </vs-td>
                        <vs-td>
                          <div class="vx-row">
                            <vx-tooltip v-if="$can('view-scheduled-tasks')" class="ml-2" text="View/Edit Details" position="left">
                              <vs-button size="small" @click.stop="onClickViewTask(data[indextr].id)"
                                         color="warning" type="filled" icon-pack="feather" icon="icon-eye"></vs-button>
                            </vx-tooltip>

                            <vx-tooltip v-else class="ml-2" text="Permission Required to View Task Details" position="left">
                              <vs-button size="small" disabled
                                         color="warning" type="filled" icon-pack="feather" icon="icon-eye"
                                         style="opacity: 0.5; cursor: not-allowed;"></vs-button>
                            </vx-tooltip>
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>

              </div>
            </div>
            <div class="vx-row mt-8 hiddenSection">
              <div class="vx-col">
                <h5 class="mb-2 mt-2" style="color: #626262">Manufacturing Variance</h5>
                <small>Actual quantity produced Kg ( Variance - {{orderDetails.variance || '0'}} % )</small>
                <vs-input disabled :value="totalQuantity" class="w-full required" />
              </div>
            </div>
            <div class="vx-row mt-8 hiddenSection">
              <div class="vx-col">
                <h5 class="mb-2 mt-2" style="color: #626262">Manufacturing Instruction</h5>
                {{ orderDetails.manufacturing_instruction }}
              </div>
            </div>
          </div>

          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <div class="flex flex-wrap items-center justify-end mt-8 ">
              <h5 class="mb-4" style="color: #626262">Recipe Summary</h5>
              <span  v-if="isInProgressStatus || isPausedStatus" class="mr-0 ml-auto">RM Batch confirmed |</span>
              <span  v-if="isInProgressStatus || isPausedStatus" class="mr-0 ml-2">Added to WIP</span>
            </div>

            <div class="item-list py-4 px-4 	mb-8" v-for="(stock, index) in orderDetails.reblended_stock" :key="stock.id">
              <div class="flex mb-4 items-center ">
                <span class="w-full  text-green">
                  <span class="font-bold text-xl">
                    {{ stock.name }} <small class="text-xs ml-2 text-white p-1 bg-primary">REBLEND</small>
                    <br>
                  <span class="text-lg"> {{stock.completed_quantity }} Kg </span> <br>
                  </span>
                </span>

                  <vs-checkbox v-on:input="onChangeCheckBox(stock)" v-if="isInProgressStatus || isPausedStatus || isStoppedStatus" class="p-2 ml-4 mr-8" v-model="stock.is_batch_confirmed" size="large"></vs-checkbox>
                  <vs-checkbox v-on:input="onChangeCheckBox(stock)" v-if="isInProgressStatus || isPausedStatus || isStoppedStatus" :disabled="!stock.is_batch_confirmed" class="p-2 ml-8" v-model="stock.is_added_to_wip" size="large"></vs-checkbox>

              </div>
            </div>

            <div v-bind:class="{ 'item-list-danger': isStoppedStatus && orderDetails.formulation[index].is_batch_confirmed,  'item-list-success': isStoppedStatus && !orderDetails.formulation[index].is_batch_confirmed }"
                 class="bg-gray-50 py-4 px-4 mb-8"
                 v-for="(item, index) in orderDetails.formulation" :key="item.id + '-' + index">
              <div class="flex mb-4 items-center bg-gray-50">
                <span class="w-full  text-green">
                  <span v-if="item.company_product_code" class="font-bold text-xl">{{ item.category }}-{{item.company_product_code}} | {{item.company_product_name}}</span>
                  <span v-if="item.formulation_code" class="font-bold text-xl">{{ item.formulation_code }}</span>
                  <span v-if="item.code" class="font-bold text-xl">{{ item.code }}</span>
                  <span v-if="item.formulation_name" class="font-bold text-xl"> | {{ item.formulation_name }}</span>
                  <span v-if="item.name" class="font-bold text-xl"> | {{ item.name }}</span>
                  <small v-if="item.is_3rd_party_rm" class="text-xs ml-2 text-white p-1 bg-danger">3rd Party Rm</small>
                  <br>
                  <span class="text-lg"> {{item.quantity_kg }} Kg </span> <br>
                  <p class="mt-2 mb-2 font-bold ml-4" v-if="!item.is_3rd_party_rm">Locations</p>

                  <div class="ml-4 mb-2 flex items-center flex-wrap" v-for="(location, i) in item.location" :key="i" v-if="!item.is_3rd_party_rm">
                    <span>
                      <span class="font-semibold">Batch No:</span> {{location.batch_no}} | <span class="font-semibold">Qty:</span> {{Number(location.quantity).toFixed(4)}} Kg | <span v-if="item.company_product_code"><span class="font-semibold">Shelf Location:</span> L-{{location.shelf_location_l}} R-{{location.shelf_location_r}} S-{{location.shelf_location_s}}</span>
                    </span>
                    <vs-chip v-if="location.is_reserved" color="warning" class="font-semibold ml-2" style="border-radius: 4px; font-size: 11px; height: 20px;">
                      Swapped
                    </vs-chip>
                    <vs-chip v-if="location.is_short" color="danger" class="font-semibold ml-2" style="border-radius: 4px; font-size: 11px; height: 20px;">
                      Shortage
                    </vs-chip>
                  </div>

                  <!-- Reserved Batch Shortage Alerts -->
                  <div class="ml-4 mr-4 mt-2 mb-3" v-if="item.reserved_batch_errors && item.reserved_batch_errors.length > 0">
                    <vs-alert color="danger" active="true" icon-pack="feather" icon="icon-alert-triangle" class="w-full">
                      <div class="font-semibold mb-1">Reserved Batch Shortage:</div>
                      <div v-for="(err, errIdx) in item.reserved_batch_errors" :key="errIdx" class="text-sm">
                        {{ err }}
                      </div>
                      <div class="mt-2 text-xs font-semibold">
                        Please click Swap RM Batch to select another batch or Revert Batches to reset.
                      </div>
                    </vs-alert>
                  </div>

                  <!-- Swap and Revert RM Buttons (RM level) -->
                  <div class="flex items-center mt-2 ml-4 mb-3">
                    <vs-button
                      v-if="!item.is_3rd_party_rm && (!!item.company_product_code || !!item.code) && isInProgressStatus && !item.is_added_to_wip"
                      v-can="'allow-raw-materials-batch-swap'"
                      @click.stop="onClickSwapRmBatch(item, index)"
                      color="warning"
                      type="border"
                      size="small"
                      class="flex">
                      Swap RM Batch
                    </vs-button>

                    <vs-button
                      v-if="!item.is_3rd_party_rm && (!!item.company_product_code || !!item.code) && isInProgressStatus && !item.is_added_to_wip && Number(item.reserved_quantity) > 0"
                      v-can="'allow-raw-materials-batch-swap'"
                      @click.stop="onClickRevertRmBatch(item)"
                      color="danger"
                      type="border"
                      size="small"
                      class="flex ml-2">
                      Revert Batches
                    </vs-button>
                  </div>
                  <div
                    class="ml-4 mb-3 flex flex-col"
                    v-for="(location, i) in item.assigned_raw_material"
                    :key="i"
                  >

                    <div>
                      <span class="font-semibold">Batch No:</span>
                      {{ location.batch_no }}

                      <span class="mx-1">|</span>

                      <span class="font-semibold">Qty:</span>
                      {{ Number(location.quantity).toFixed(4) }} Kg
                    </div>

                    <div class="mt-2">
                      <span
                        v-if="location.supplier_batch_no"
                        class="inline-block py-1 px-2 rounded font-medium"
                        style="background:#39b24b;color:#fff;border:1px solid #2f9a40;"
                      >
                        Supplier Batch No: {{ location.supplier_batch_no }}
                      </span>

                      <span
                        v-else
                        class="inline-block py-1 px-2 rounded font-medium"
                        style="background:#DC2626;color:#fff;border:1px solid #B91C1C;"
                      >
                        Supplier Batch No: Not Added
                      </span>
                    </div>

                  </div>
                  <vs-button @click.stop="onClickUpdate3rdPartyRmBatchDetails(item)" v-if="item.is_3rd_party_rm && isInProgressStatus" icon-pack="feather" icon="icon-edit-2" size="small" type="border" class="mt-2">Update batch details</vs-button>
                  <p class="ml-4" v-if="(item.location.length === 0 && isConfirmedStatus)">N/A</p>
                </span>

                  <vs-button :disabled="isDisabledWrongItemButton(item.category, item.company_product_code)" @click="onClickWrongItem(item)" v-if="isStoppedStatus && orderDetails.formulation[index].is_batch_confirmed" color="danger" class="mr-4" type="filled">Wrong Item</vs-button>
                  <vs-checkbox v-on:input="onChangeCheckBox(item)" v-if="isInProgressStatus || isPausedStatus || isStoppedStatus || isDispatchToSupplierStatus" :disabled="orderDetails.formulation[index].is_added_to_wip || isPausedStatus || isStoppedStatus || isDispatchToSupplierStatus || (item.reserved_batch_errors && item.reserved_batch_errors.length > 0)" class="p-2 ml-4 mr-8" v-model="orderDetails.formulation[index].is_batch_confirmed" size="large"></vs-checkbox>
                  <vs-checkbox v-on:input="onChangeCheckBox(item)" v-if="isInProgressStatus || isPausedStatus || isStoppedStatus || isDispatchToSupplierStatus" :disabled="!orderDetails.formulation[index].is_batch_confirmed || orderDetails.formulation[index].is_added_to_wip || (item.reserved_batch_errors && item.reserved_batch_errors.length > 0)" class="p-2 ml-8" v-model="orderDetails.formulation[index].is_added_to_wip" size="large"></vs-checkbox>

              </div>
              <div class="vx-row" v-if="isInProgressStatus">
                <div class="vx-col w-full">
                  <vs-alert v-if="checkLocationQtyAndTotalQty(item.quantity_kg, item.location) && (item.location.length !== 0 && item.assigned_raw_material.length > 0)" color="danger" active="true" class="w-full" icon-pack="feather" icon="icon-info">
                    Rm quantity exceeds the stock quantity.
                  </vs-alert>
                </div>
              </div>
            </div>

          </div>

          <div class="vx-col md:w-1/4 w-full md:mb-0">
            <div class="hiddenSection">
            <h5 class="mb-4" style="color: #626262">Actions</h5>
            <vs-button v-if="isConfirmedStatus || isPausedStatus || isReturnedFromSupplierStatus" @click="onClickStartConfirm" color="primary" type="filled" size="large" class="w-full py-16 font-bold text-3xl">{{isPausedStatus || isReturnedFromSupplierStatus ? 'Restart' : 'Start'}}</vs-button>
            <vs-button v-if="isInProgressStatus" @click="onClickAction('pause')" color="warning" type="filled" size="large" class="w-full py-16 font-bold text-3xl">Pause</vs-button>
            <vs-button v-if="isInProgressStatus" @click="onClickAction('stop')" v-can="'stop-work-orders'" color="danger" type="filled" size="large" class="w-full py-16 font-bold text-3xl mt-2">Stop</vs-button>
            <vs-button v-if="isSprayDryProduct && isInProgressStatus && !orderDetails.dispatch_to_supplier" @click="onClickAction('disptach-to-supplier')" :disabled="!allItemsAddedExceptCarriers"  color="primary" type="filled" size="large" class="w-full py-16 font-bold text-3xl mt-2">Dispatch to Supplier</vs-button>
            <vs-button v-if="isDispatchToSupplierStatus && orderDetails.dispatch_to_supplier" @click="onClickAction('returned-from-supplier')" :disabled="!allItemsAddedExceptCarriers"  color="primary" type="filled" size="large" class="w-full py-16 font-bold text-3xl mt-2">Return from Supplier</vs-button>
            <vs-button :disabled="checkButton" v-if="isInProgressStatus" @click="onClickAction('mix_complete')" color="primary" type="filled" size="large" class="w-full py-16 font-bold text-3xl mt-2">Mix Complete</vs-button>
            <vs-button @click="onClickAction('submitted_to_q_c')" v-if="isSampleTakenByQc" color="warning" type="filled" size="large" class="w-full py-16 font-bold text-3xl mt-2">Submit to QC</vs-button>
            <vs-button v-if="isNotSubmittedToQc && (isMixCompletedStatus || isPackOffInProgressStatus || isPackOffCompletedStatus)"   @click="onClickAction('q_c_sample_taken')" color="warning" type="filled" size="large" class="w-full py-16 font-bold text-3xl mt-2">Sample collected for QC</vs-button>
            <vs-button @click="onClickSundryItemAdd()" v-if="isMixCompletedStatus || isPackOffInProgressStatus"  color="primary" type="filled" size="large" class="w-full py-16 font-bold text-3xl mt-2">Start Pack Off</vs-button>

            <vs-button disabled v-if="isPackOffCompletedStatus"  color="primary" type="filled" size="large" class="w-full py-16 font-bold text-3xl mt-2">Pack Off Completed</vs-button>
            <vs-button disabled v-if="isStoppedStatus"  color="danger" type="filled" size="large" class="w-full py-16 font-bold text-3xl mt-2">Work Order Stopped</vs-button>

            <vs-button @click="onCLickStartCleanDown()" v-if="isPackOffCompletedStatus && !orderDetails.actual_start_clean_time"  color="primary" type="filled" size="large" class="w-full py-16 font-bold text-3xl mt-2">Start Clean Down</vs-button>
            <vs-button @click="onCLickEndCleanDown()" v-if="orderDetails.actual_start_clean_time && !orderDetails.actual_end_clean_time" color="warning" type="filled" size="large" class="w-full py-16 font-bold text-3xl mt-2">End Clean Down</vs-button>
            </div>
            <br>

            <div class="vx-row mt-8 px-1">
              <div class="vx-col w-1/4 font-bold text-sm">WORK ORDER</div>
              <div class="vx-col w-1/4 font-semibold">Planned</div>
              <div class="vx-col w-1/4 font-semibold">Start Time</div>
              <div class="vx-col w-1/4">{{orderDetails.work_order_date}} {{__utcToLocalTime(orderDetails.start_time)}}</div>
            </div>
            <div class="vx-row mt-8 px-1">
              <div class="vx-col w-1/4 font-semibold"></div>
              <div class="vx-col w-1/4 font-semibold"></div>
              <div class="vx-col w-1/4 font-semibold">End Time</div>
              <div class="vx-col w-1/4">{{orderDetails.work_order_date}} {{__utcToLocalTime(orderDetails.end_time)}}</div>
            </div>
            <div class="vx-row mt-8 px-1">
              <div class="vx-col w-1/4 font-semibold"></div>
              <div class="vx-col w-1/4 font-semibold">Actual</div>
              <div class="vx-col w-1/4 font-semibold">Start Time</div>
              <div class="vx-col w-1/4">{{orderDetails.actual_start_date}} {{__utcToLocalTime(orderDetails.actual_start_time)}}</div>
            </div>
            <div class="vx-row mt-8 px-1">
              <div class="vx-col w-1/4 font-semibold"></div>
              <div class="vx-col w-1/4 font-semibold"></div>
              <div class="vx-col w-1/4 font-semibold">End Time</div>
              <div class="vx-col w-1/4">{{orderDetails.actual_end_date}} {{__utcToLocalTime(orderDetails.actual_end_time)}}</div>
            </div>

            <div class="vx-row mt-8 px-1">
              <div class="vx-col w-1/4 font-bold text-sm">CLEAN DOWN</div>
              <div class="vx-col w-1/4 font-semibold">Planned</div>
              <div class="vx-col w-1/4 font-semibold">Start Time</div>
              <div class="vx-col w-1/4">{{orderDetails.work_order_date}} {{__utcToLocalTime(orderDetails.end_time)}}</div>
            </div>
            <div class="vx-row mt-8 px-1">
              <div class="vx-col w-1/4 font-semibold"></div>
              <div class="vx-col w-1/4 font-semibold"></div>
              <div class="vx-col w-1/4 font-semibold">End Time</div>
              <div class="vx-col w-1/4">{{orderDetails.work_order_date}} {{__utcToLocalTime(plannedCleanDownEndTime)}}</div>
            </div>
            <div class="vx-row mt-8 px-1">
              <div class="vx-col w-1/4 font-semibold"></div>
              <div class="vx-col w-1/4 font-semibold">Actual</div>
              <div class="vx-col w-1/4 font-semibold">Start Time</div>
              <div class="vx-col w-1/4">{{orderDetails.actual_start_date}} {{__utcToLocalTime(orderDetails.actual_start_clean_time)}}</div>
            </div>
            <div class="vx-row mt-8 px-1">
              <div class="vx-col w-1/4 font-semibold"></div>
              <div class="vx-col w-1/4 font-semibold"></div>
              <div class="vx-col w-1/4 font-semibold">End Time</div>
              <div class="vx-col w-1/4">{{orderDetails.actual_end_date}} {{__utcToLocalTime(orderDetails.actual_end_clean_time)}}</div>
            </div>


<!--            <div class="overflow-hidden sm:rounded-lg ">-->
<!--              <div class="border-t border-gray-200">-->
<!--                <dl>-->
<!--                  <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6">-->
<!--                    <dt class="text-sm font-semibold text-gray-500">-->
<!--                      Work order date-->
<!--                    </dt>-->
<!--                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">-->
<!--                      {{orderDetails.work_order_date}}-->
<!--                    </dd>-->
<!--                  </div>-->
<!--                  <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6">-->
<!--                    <dt class="text-sm font-semibold text-gray-500">-->
<!--                      Work order start time-->
<!--                    </dt>-->
<!--                    <dt class="text-sm font-semibold text-gray-500">-->
<!--                      Work order start time-->
<!--                    </dt>-->
<!--                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">-->
<!--                      {{__utcToLocalTime(orderDetails.start_time)}}-->
<!--                    </dd>-->
<!--                  </div>-->
<!--                  <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6">-->
<!--                    <dt class="text-sm font-semibold text-gray-500">-->
<!--                      Work order end time-->
<!--                    </dt>-->
<!--                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">-->
<!--                      {{__utcToLocalTime(orderDetails.end_time)}}-->
<!--                    </dd>-->
<!--                  </div>-->
<!--                  <div v-if="orderDetails.actual_start_time" class="bg-white px-4 py-5 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6">-->
<!--                    <dt class="text-sm font-semibold text-gray-500">-->
<!--                      Work order actual start time-->
<!--                    </dt>-->
<!--                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">-->
<!--                      {{ orderDetails.actual_start_time ? __utcToLocalTime(orderDetails.actual_start_time) : 'N/A'}}-->
<!--                    </dd>-->
<!--                  </div>-->
<!--                  <div v-if="orderDetails.actual_end_time" class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6">-->
<!--                    <dt class="text-sm font-semibold text-gray-500">-->
<!--                      Work order actual end time-->
<!--                    </dt>-->
<!--                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">-->
<!--                      {{ orderDetails.actual_end_time ? __utcToLocalTime(orderDetails.actual_end_time) : 'N/A'}}-->
<!--                    </dd>-->
<!--                  </div>-->
<!--                  <div v-if="orderDetails.actual_start_clean_time" class="bg-white px-4 py-5 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6">-->
<!--                    <dt class="text-sm font-semibold text-gray-500">-->
<!--                      Work order actual start clean time-->
<!--                    </dt>-->
<!--                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">-->
<!--                      {{ orderDetails.actual_start_clean_time ? __utcToLocalTime(orderDetails.actual_start_clean_time) : 'N/A'}}-->
<!--                    </dd>-->
<!--                  </div>-->
<!--                  <div v-if="orderDetails.actual_end_clean_time" class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6">-->
<!--                    <dt class="text-sm font-semibold text-gray-500">-->
<!--                      Work order actual end clean time-->
<!--                    </dt>-->
<!--                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">-->
<!--                      {{ orderDetails.actual_end_clean_time ? __utcToLocalTime(orderDetails.actual_end_clean_time) : 'N/A'}}-->
<!--                    </dd>-->
<!--                  </div>-->
<!--                  <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6">-->
<!--                    <dt class="text-sm font-semibold text-gray-500">-->
<!--                      Remaining Time-->
<!--                    </dt>-->
<!--                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">-->
<!--                      00:00-->
<!--                    </dd>-->
<!--                  </div>-->
<!--                </dl>-->
<!--              </div>-->
<!--            </div>-->
            <br>
            <h5 v-can="'view-work-order-logs'"  class="mb-4">Work Order Log</h5>
            <vs-table v-can="'view-work-order-logs'"  :hoverFlat="true"  noDataText="">

              <template slot="thead">
                <vs-th class="text-xs">USER</vs-th>
                <vs-th class="text-xs">DATE/TIME</vs-th>
                <!-- <vs-th class="text-xs">PREVIOUS STATUS</vs-th> -->
                <vs-th class="text-xs">STATUS CHANGED TO</vs-th>
                <!-- <vs-th class="text-xs">REASON</vs-th> -->
              </template>
              <template>
                <vs-tr :key="index" v-for="(tr, index) in logs">

                  <vs-td class="text-xs">
                    {{tr.staff.name}}
                  </vs-td>

                  <vs-td  class="text-xs">
                    {{ __dateTimeFormatter(tr.created_at) }}
                  </vs-td>

                  <!-- <vs-td class="text-xs">
                    {{ tr.properties.old.status_id ? getStatusName(tr.properties.old.status_id) : tr.properties.old.q_c_status}}
                  </vs-td> -->

                  <vs-td class="text-xs">
                    {{tr.status }}
                  </vs-td>

                  <!-- <vs-td  class="text-xs">
                    {{ tr.properties.reason_for_change || 'N/A' }}
                  </vs-td> -->

                </vs-tr>
              </template>
            </vs-table>
            <span v-if="orderDetails.formulation_type === 'spray dry powder' && orderDetails.dispatch_to_supplier" class="text-sm">
              Note: Work order dispatched to "{{orderDetails.dispatch_to_supplier.supplier.company_name}}" at {{ orderDetails.dispatch_to_supplier.dispatched_at }}
            </span>
          </div>
        </div>

      </div>
    </vx-card>
    <vs-popup classContent="popup-example" :title="status_change.status + ' work order'" :active.sync="statusActivePopup">
      <div class="vx-row" v-if="status_change.status === 'stop'">
        <div class="vx-col w-full">
          <vs-alert active="true" class="h-full" color="warning">
            Stopping the wo will change the time in the timeline
          </vs-alert>
        </div>
      </div>
      <div class="vx-row mb-3 mt-5">
        <div class="vx-col w-full md:mb-0">
          <small class="label"> Reason </small>
          <v-select v-model="status_change.reason_for_change" style="border-radius: 0; z-index: 9" :options="status_change.status === 'pause' ? pause_reasons : stop_reasons" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-3 mt-5" v-if="status_change.reason_for_change === 'Other'">
        <div class="vx-col w-full md:mb-0">
          <vs-input v-model="status_change.reason" class="w-full required" />
        </div>
      </div>
      <div class="flex flex-wrap items-center justify-end mt-8" >
        <vs-button @click="changeStatus" id="save_change_button" button="submit" class="ml-auto mt-2">Confirm</vs-button>
      </div>
    </vs-popup>
    <vs-popup class="add-ccp-items-popup" classContent="popup-example" title="Add CCP Items" :active.sync="openCcpItemPopup">

      <vs-table :onlyClickCheckbox="true" v-model="selected_ccp_list" multiple :hoverFlat="true" :data="ccp_items">

        <template slot="thead">
          <vs-th width="25%">Name</vs-th>
          <vs-th width="50%">Description</vs-th>
          <vs-th width="25%">Comment</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>

            <vs-td :data="data[indextr].description">
              <vx-read-more :text="data[indextr].description" :length="100"/>
            </vs-td>

            <vs-td :data="data[indextr].comment">
              <vs-input type="text" v-model="data[indextr].comment"
                        class="w-full"
                        :name="indextr+'comment'"
                        val-icon-danger="icon-x"
                        val-icon-pack="feather"/>
            </vs-td>
            <template class="expand-user" slot="expand">
              <div class="con-expand-users w-full p-12">
                {{ data[indextr].file_paths }}
              </div>
            </template>

          </vs-tr>
        </template>
      </vs-table>

      <div class="flex flex-wrap items-center justify-end mt-8" >
        <vs-button :disabled="selected_ccp_list.length === 0" @click="onClickAddCcpItem" id="save_changdde_button" button="submit" class="ml-auto mt-2">Confirm</vs-button>
      </div>
      <vs-popup class="rm-wrong-item-pop-up" classContent="popup-example" title="CCP DESCRIPTION" :active.sync="openCcpItemDescription">
        {{ selected_ccp_description }}
      </vs-popup>
    </vs-popup>
    <vs-popup class="sundry-item-list-table" classContent="popup-example" title="Create WO with sundry items" :active.sync="openSundryItemPopUp">
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-courier-supplier-popup" @submit.prevent="handleSubmit(addSundryItem)" autocomplete="off">
          <div class="vx-row mb-3 mt-5">
            <div class="vx-col w-full md:mb-0">
              <vs-input placeholder="search items" v-model="searchText" @input="searchSundryItems" class="mb-4"/>
              <vs-table
                id="sundry-item-list-table"
                :max-items="(meta.per_page) ? meta.per_page : 10"
                pagination
                :data="sundry_items_inventory"
                stripe
                class="table-auto vs-con-loading__container mt-4">

                <template slot="thead">
                  <vs-th width="20%" class="text-xs">SUNDRY BATCH CODE</vs-th>
                  <vs-th width="10%" class="text-xs">BATCH QTY (KG)</vs-th>
                  <vs-th width="10%" class="text-xs">COMPLETED/ AVAILABLE QTY (KG)</vs-th>
                  <vs-th width="10%" class="text-xs">SUNDRY ITEM CODE</vs-th>
                  <vs-th width="10%" class="text-xs">SUNDRY PRODUCT CODE</vs-th>
                  <vs-th width="10%" class="text-xs">SUNDRY PRODUCT NAME</vs-th>
                  <vs-th width="10%" class="text-xs">STATUS</vs-th>
                  <vs-th width="20%" class="text-xs">QUANTITY (Item)</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td class="text-primary font-semibold" :data="data[indextr].batch_no">
                      {{ data[indextr].code | 'N/A'}}
                    </vs-td>

                    <vs-td :data="data[indextr].total_quantity">
                      {{ data[indextr].total_quantity}}
                    </vs-td>


                    <vs-td :data="data[indextr].available_quantity">
                      {{ data[indextr].available_quantity}}
                    </vs-td>

                    <vs-td :data="data[indextr].sundry_item_code">
                      {{ data[indextr].sundry_item_code}}
                    </vs-td>

                    <vs-td :data="data[indextr].sundry_product_code">
                      {{ data[indextr].sundry_product_code}}
                    </vs-td>

                    <vs-td :data="data[indextr].sundry_product_name">
                      {{ data[indextr].sundry_product_name}}
                    </vs-td>

                    <vs-td :data="data[indextr].status">
                      <vs-chip transparent :color="'dark'" class="w-32">
                        {{ data[indextr].status === 'In_Stock' ? 'In Stock' : ''}}
                      </vs-chip>
                    </vs-td>


                    <vs-td>
                        <ValidationProvider :vid="indextr+ 'quantity'" :name="indextr+ 'quantity'" :rules="`min_qty:${data[indextr].available_quantity}`" v-slot="{ errors }">
                          <vs-input v-model="data[indextr].quantity" class="w-full required"
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                        </ValidationProvider>
                    </vs-td>

                  </vs-tr>
                </template>


              </vs-table>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8" >
            <vs-button button="submit" class="ml-auto mt-2">Confirm</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vs-popup>
    <vs-popup class="sundry-item-list-table" classContent="popup-example" title="Update WO with sundry items" :active.sync="openUpdateSundryItemPopUp">
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-courier-supplier-popup" @submit.prevent="handleSubmit(updateSundryItem)" autocomplete="off">
      <div class="vx-row mb-3 mt-5">
        <div class="vx-col w-full md:mb-0">
          <vs-input placeholder="search items" v-model="searchText" @input="searchSundryItems"/>
          <vs-table
            id="sundry-item-update-list-table"
            :max-items="(meta.per_page) ? meta.per_page : 10"
            pagination
            :data="sundry_items_inventory"
            sort
            :sst="true"
            class="table-dark-inverted table-auto vs-con-loading__container">

            <template slot="thead">
              <vs-th width="30%"  class="text-xs">SUNDRY BATCH CODE</vs-th>
              <vs-th width="10%" class="text-xs">BATCH QTY (KG)</vs-th>
              <vs-th width="10%" class="text-xs">COMPLETED/ AVAILABLE QTY (KG)</vs-th>
              <vs-th width="10%" class="text-xs">SUNDRY ITEM CODE</vs-th>
              <vs-th width="10%" class="text-xs">SUNDRY PRODUCT CODE</vs-th>
              <vs-th width="10%" class="text-xs">SUNDRY PRODUCT NAME</vs-th>
              <vs-th width="10%" class="text-xs">STATUS</vs-th>
              <vs-th width="10%" class="text-xs">QUANTITY (Item)</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                <vs-td class="text-primary font-semibold" :data="data[indextr].code">
                  {{ data[indextr].code || 'N/A'}}
                </vs-td>

                <vs-td :data="data[indextr].total_quantity">
                  {{ data[indextr].total_quantity}}
                </vs-td>


                <vs-td :data="data[indextr].available_quantity">
                  {{ data[indextr].available_quantity}}
                </vs-td>

                <vs-td :data="data[indextr].sundry_item_code">
                  {{ data[indextr].sundry_item_code}}
                </vs-td>

                <vs-td :data="data[indextr].sundry_product_code">
                  {{ data[indextr].sundry_product_code}}
                </vs-td>

                <vs-td :data="data[indextr].sundry_product_name">
                  {{ data[indextr].sundry_product_name}}
                </vs-td>

                <vs-td :data="data[indextr].status">
                  <vs-chip transparent :color="'dark'" class="w-32">
                    {{ data[indextr].status === 'In_Stock' ? 'In Stock' : ''}}
                  </vs-chip>
                </vs-td>


                <vs-td >
                  <div class="vx-row">
                    <ValidationProvider :vid="`qty_${indextr}`" :name="`qty_${indextr}`" :rules="`min_qty:${data[indextr].max}`" v-slot="{ errors }">
                    <vs-input v-model="data[indextr].quantity" class="w-full required" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </vs-td>

              </vs-tr>
            </template>


          </vs-table>
        </div>
      </div>
      <div class="flex flex-wrap items-center justify-end mt-8" >
        <vs-button button="submit" class="ml-auto mt-2">Confirm</vs-button>
      </div>
      </form>
      </ValidationObserver>
    </vs-popup>
    <create-work-order-with-sundry-item-pop-up ref="createWorkOrderWithSundryItemPopUp"/>
    <add-qc-test-work-order-pop-up v-on:refreshData="refreshData()" ref="addQcTestWorkOrderPopUp"/>
    <label-pdf-pop-up ref="labelPdfPopUp"/>

    <vs-popup class="label-popup" classContent="popup-example" title="" :active.sync="openLabelPopup">
      <div class="vx-row mb-12 mt-2">
        <h3 class="ml-8 uppercase font-semibold">
          {{ orderDetails.formulation_name }}
        </h3>
      </div>
      <div class="vx-row mb-3 mt-2">
        <div class="vx-col w-1/2 md:mb-0">
          <img class="responsive w-64" src="https://cdn.pixabay.com/photo/2012/04/24/12/29/no-symbol-39767_1280.png" alt="">
          <img class="responsive w-64" src="https://cdn.pixabay.com/photo/2012/04/24/12/29/no-symbol-39767_1280.png" alt="">
          <img class="responsive w-64" src="https://cdn.pixabay.com/photo/2012/04/24/12/29/no-symbol-39767_1280.png" alt="">
          <img class="responsive w-64" src="https://cdn.pixabay.com/photo/2012/04/24/12/29/no-symbol-39767_1280.png" alt="">
        </div>
        <div class="vx-col w-1/2 md:mb-0">
          <div class="overflow-hidden sm:rounded-lg ">
            <div class="border-t border-gray-200">
              <dl>
                <div class="bg-gray-50 px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt class="text-sm font-semibold text-gray-500">
                    Code Number
                  </dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {{ orderDetails.formulation_code }}
                  </dd>
                </div>
                <div class="bg-white px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt class="text-sm font-semibold text-gray-500">
                    Batch
                  </dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {{orderDetails.work_order_code}}/{{orderDetails.formulation_code}}
                  </dd>
                </div>
                <div class="bg-white px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt class="text-sm font-semibold text-gray-500">
                    Weight
                  </dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {{ Number(labelData.quantity).toFixed(4) }}
                  </dd>
                </div>
                <div class="bg-white px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt class="text-sm font-semibold text-gray-500">
                    Manufactured
                  </dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    N/A
                  </dd>
                </div>
                <div class="bg-white px-4 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt class="text-sm font-semibold text-gray-500">
                    Best Before
                  </dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    N/A
                  </dd>
                </div>
              </dl>
            </div>
          </div>
          <h4 class="mt-8"> Warning</h4>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab blanditiis fugiat natus nesciunt nihil possimus qui veniam. Cupiditate, distinctio earum harum id inventore iste quia veritatis vitae! Ab fugit, perferendis.</p>
        </div>
      </div>
      <div class="vx-row mb-4 mt-8">
        <h6 class="ml-8">
          Innovation House, Abex Road, Newbury, Berkshire, RG14 5EY
        </h6>
      </div>
    </vs-popup>
    <vs-popup class="status-change-confirm" classContent="popup-example" title="Confirm" :active.sync="openStatusChangeConfirm">
      <div class="vx-row mb-3 mt-5">
        <div class="vx-col w-full md:mb-0">
          <p>
            Once a work order is stopped, it cannot be restarted. You can pause the work order instead if you want to use in future. Are you sure you want to stop this WO?
          </p>
        </div>
      </div>
      <div class="flex flex-wrap items-center justify-end mt-8">
        <vs-button @click="onClickStopConfirm" color="danger" class="ml-auto mt-2">Confirm</vs-button>
        <vs-button @click="openStatusChangeConfirm = false" class="ml-4 mt-2" type="border" color="dark">Cancel</vs-button>
      </div>
    </vs-popup>
    <vs-popup class="start-tank-confirm" classContent="popup-example" title="Confirm" :active.sync="openStartTankConfirm">
      <div class="vx-row mb-3 mt-5">
        <div class="vx-col w-full md:mb-0">
          <p>Are you sure the tank is clean?</p>
        </div>
      </div>
      <div class="flex flex-wrap items-center justify-end mt-8">
        <vs-button @click="proceedStart" color="primary" class="ml-auto mt-2">Yes</vs-button>
        <vs-button @click="openStartTankConfirm = false" class="ml-4 mt-2" type="border" color="dark">No</vs-button>
      </div>
    </vs-popup>

    <vs-popup class="rm-wrong-item-pop-up" classContent="popup-example" title="Wrong item return to inventory" :active.sync="openRmWasteItemReturn">
      <div class="vx-row mb-3 mt-5">
        <div class="vx-col w-1/2md:mb-0">
          Allocated Item
        </div>
        <div class="vx-col w-1/2md:mb-0">
          {{ wrong_item.category }}-{{ wrong_item.company_product_code }}
        </div>
      </div>
      <div class="vx-row mb-3 mt-5 mb-8">
        <div class="vx-col w-1/2md:mb-0">
          Quantity (KG)
        </div>
        <div class="vx-col w-1/2md:mb-0">
          {{ wrong_item.quantity_kg }}
        </div>
      </div>
      <P>
        Is the above batch unused and free to return to RM inventory?
      </P>
      <hr class="mt-4 mb-8">
      <P>
        Did you add any RM by mistake?
        <vs-switch v-model="is_added_any_rm_by_mistake" class="mt-4"/>
      </P>
      <div class="vx-row" v-if="is_added_any_rm_by_mistake">
        <div class="vx-col w-full">
          <vs-input v-on:input="onInputRmInventorySeach" v-model="inventory_search_term" icon-pack="feather" icon="icon-search" placeholder="Search RM code"
                    class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />

          <vs-table
            @selected="handleSelectedWrongRm"
            :data="rm_inventory_list"
            multiple
            v-model="selected_rm_inventory"
            stripe class="table-dark-inverted table-auto vs-con-loading__container">

            <template slot="thead">
              <vs-th width="15%"  class="text-sm">BATCH NO</vs-th>
              <vs-th width="10%"  class="text-sm" sort-key="sundry_item_code">ITS PRODUCT CODE</vs-th>
              <vs-th width="10%"  class="text-sm" sort-key="sundry_product_code">ITS PRODUCT NAME</vs-th>
              <vs-th width="10%" class="text-sm">SHELF LOCATION</vs-th>
              <vs-th width="10%" class="text-sm">MANUFACTURE DATE</vs-th>
              <vs-th width="10%" class="text-sm">EXPIRATION DATE</vs-th>
              <vs-th width="10%" class="text-sm">TOTAL QTY IN STOCK (Kg)</vs-th>
              <vs-th width="10%" class="text-sm">STATUS</vs-th>
<!--              <vs-th width="5%" class="text-sm"></vs-th>-->
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                <vs-td :data="data[indextr].batch_no">
                  {{ data[indextr].batch_no}}
                </vs-td>

                <vs-td class="text-primary font-semibold" :data="data[indextr].company_product_code">
                  {{ data[indextr].category }}-{{ data[indextr].company_product_code}}
                </vs-td>

                <vs-td :data="data[indextr].company_product_name">
                  {{ data[indextr].company_product_name}}
                </vs-td>

                <vs-td>
                  R {{ data[indextr].shelf_location_r || '-'}} | S {{ data[indextr].shelf_location_s || '-'}} | L {{ data[indextr].shelf_location_l || '-'}}
                </vs-td>


                <vs-td :data="data[indextr].manufacture_date">
                  {{ data[indextr].manufacture_date}}
                </vs-td>

                <vs-td :data="data[indextr].expiration_date">
                  {{ data[indextr].expiration_date}}
                </vs-td>

                <vs-td :data="data[indextr].available_quantity">
                  {{ Number(data[indextr].available_quantity).toFixed(4)}}
                </vs-td>

                <vs-td :data="data[indextr].status">
                  <vs-chip transparent :color="'dark'" class="w-32">
                    {{ data[indextr].status}}
                  </vs-chip>
                </vs-td>


<!--                <vs-td >-->
<!--                  <div class="vx-row">-->
<!--                    <vx-tooltip text="Update rm stock" position="left">-->
<!--                      <vs-chip v-if="selected_rm_inventory.id === data[indextr].id" transparent :color="'success'" style="border-radius: 0" >-->
<!--                        selected-->
<!--                      </vs-chip>-->
<!--                    </vx-tooltip>-->
<!--                  </div>-->
<!--                </vs-td>-->

              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>

      <div class="vx-row mx-8 mt-8 mb-8" v-if="affected_rm_list.length > 0">
        <div class="vx-col">
          <h5>There is not enough unallocated RM to cover this error. The following Work Order(s) will be removed from the manufacturing plan</h5>
          <br>
          <span class="text-primary" v-for="(affected, index_affected) in affected_rm_list" :key="index_affected">

              <vs-chip class="cursor-pointer rounded-none mr-2" transparent color="danger">
                <vx-tooltip text="View Work Order" position="top">
                  {{ affected.work_order_code }}
                </vx-tooltip>
              </vs-chip>
          </span>
        </div>
      </div>

      <div v-if="selected_rm_inventory.length > 0 && is_added_any_rm_by_mistake">
        <div class="vx-row mb-3 mt-4 mx-8" v-for="(inventory_waste, index_rm_waste) in selected_rm_inventory" :key="index_rm_waste">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <small class="label">Batch Number</small>
            <vs-input v-model="inventory_waste.batch_no" disabled  name="credit_limit" class="w-full required" label=""/>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <small class="label">Quantity (Kg)</small>
            <vs-input v-on:input="onInventoryWasteInputValidate(index_rm_waste)" v-model="inventory_waste.quantity"  name="quantity" class="w-full required" label=""/>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap items-center justify-end mt-8">
        <vs-button @click="onCLickReturnToInventory" color="danger" class="ml-auto mt-2">Confirm</vs-button>
        <vs-button @click="openRmWasteItemReturn = false" class="ml-4 mt-2" type="border" color="dark">Cancel</vs-button>
      </div>
    </vs-popup>

    <!-- <vs-popup class="app-qr-popup" classContent="popup-example" title="WORK ORDER JOB QR" :active.sync="openAppQr">
      <vx-card class=text-center>
        <qrcode-vue :value="qr_data" :size="'150'" />
      </vx-card>
    </vs-popup> -->

    <vs-prompt
      @cancel="cancel3rdPartyRmBatchPrompt()"
      @accept="add3rdPartyRm()"
      @close="cancel3rdPartyRmBatchPrompt()"
      :title="`Enter Batch Details - Required Quantity ${selected_3rd_party_rm_payload.quantity_kg}KG`"
      :accept-text="'Add & Confirm'"
      :is-valid="spray_dry_batches.reduce((a, b) => a + Number(b.quantity), 0) == selected_3rd_party_rm_payload.quantity_kg"
      color="primary"
      class="batch-details-enter-prompt"
      :active.sync="activePromptSprayDryBtach">
      <div class="con-exemple-prompt">

        <vs-alert color="danger" class="h-auto mb-2" v-if="spray_dry_batches.reduce((a, b) => a + Number(b.quantity), 0) > 0 && spray_dry_batches.reduce((a, b) => a + Number(b.quantity), 0) != selected_3rd_party_rm_payload.quantity_kg">
          The total entered quantity ({{ Number(spray_dry_batches.reduce((a, b) => a + Number(b.quantity), 0)).toFixed(4) }}) is not matching the required quantity ({{selected_3rd_party_rm_payload.quantity_kg}}). Please adjust the batch quantities.
        </vs-alert>
        
        <div class="vx-row mb-2" v-for="(item, index) in spray_dry_batches" :key="index">
          <div class="vx-col w-2/5">
            <small class="label">Batch Number</small>
            <vs-input class="w-full" v-model="item.number"></vs-input>
          </div>
          <div class="vx-col w-2/5">
            <small class="label">Quantity(Kg)</small>
            <vs-input class="w-full" v-model="item.quantity" step="0.0001" type="number"></vs-input>
          </div>
          <div class="vx-col w-1/5">
            <vs-button @click.stop="spray_dry_batches.splice(index, 1)" size="small" color="danger" icon-pack="feather" icon="icon-x" class="mt-8"></vs-button>
          </div>
        </div>
        <vs-button @click="spray_dry_batches.push({number: '', quantity: 0 })" size="small" icon-pack="feather" icon="icon-plus" class="ml-0 mr-auto mt-3">Add new batch</vs-button>
      </div>
    </vs-prompt>

    <vs-prompt
      @cancel="activePromptSprayDryBtachUpdate = false"
      @accept="update3rdPartyRmBatchDetails()"
      @close="activePromptSprayDryBtachUpdate = false"
      :title="`Update Batch Details - Required Quantity ${selected_3rd_party_rm_payload.quantity_kg}KG`"
      :accept-text="'Update'"
      :is-valid="spray_dry_batches.reduce((a, b) => a + Number(b.quantity), 0) == selected_3rd_party_rm_payload.quantity_kg"
      color="primary"
      class="batch-details-enter-prompt"
      :active.sync="activePromptSprayDryBtachUpdate">
      <div class="con-exemple-prompt">

        <vs-alert color="danger" class="h-auto mb-2" v-if="spray_dry_batches.reduce((a, b) => a + Number(b.quantity), 0) > 0 && spray_dry_batches.reduce((a, b) => a + Number(b.quantity), 0) != selected_3rd_party_rm_payload.quantity_kg">
          The total entered quantity ({{ Number(spray_dry_batches.reduce((a, b) => a + Number(b.quantity), 0)).toFixed(4) }}) is not matching the required quantity ({{selected_3rd_party_rm_payload.quantity_kg}}). Please adjust the batch quantities.
        </vs-alert>
        
        <div class="vx-row mb-2" v-for="(item, index) in spray_dry_batches" :key="index">
          <div class="vx-col w-2/5">
            <small class="label">Batch Number</small>
            <vs-input class="w-full" v-model="item.number"></vs-input>
          </div>
          <div class="vx-col w-2/5">
            <small class="label">Quantity(Kg)</small>
            <vs-input class="w-full" v-model="item.quantity" step="0.0001" type="number"></vs-input>
          </div>
          <div class="vx-col w-1/5">
            <vs-button @click.stop="spray_dry_batches.splice(index, 1)" size="small" color="danger" icon-pack="feather" icon="icon-x" class="mt-8"></vs-button>
          </div>
        </div>
        <vs-button @click="spray_dry_batches.push({number: '', quantity: 0 })" size="small" icon-pack="feather" icon="icon-plus" class="ml-0 mr-auto mt-3">Add new batch</vs-button>
      </div>
    </vs-prompt>

    <vs-popup classContent="popup-example" :title="'WO Dispatch to Supplier'" :active.sync="dispatchToSupplierActivePopup">
      <div class="vx-row mb-3 mt-5">
        <div class="vx-col w-full md:mb-0">
          <small class="label">Supplier</small>
          <v-select v-model="status_change.supplier_id" label="company_name" :reduce="option => option.id"
          style="border-radius: 0; z-index: 9" :options="supplier_list" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="flex flex-wrap items-center justify-end mt-8" >
        <vs-button @click="changeStatus" id="save_change_button" button="submit" class="ml-auto mt-2">Confirm</vs-button>
      </div>
    </vs-popup>

    <ManageWorkOrderCcpItemsPopup ref="ManageWorkOrderCcpItemsPopup" @refreshData="refreshData()"/>

    <vs-popup class="rm-batch-swap" classContent="rm-batch-swape" title="SWAP RM BATCH" :active.sync="activeRmSwap">
      <vx-card>
        <div class="mb-4">
          <span class="text-warning"> Required Quantity (KG) : </span> {{ calculateRequiredQuantityForBatchSwap() }}
          <span class="text-warning ml-4"> Selected Quantity (KG) : </span>{{ calculateSelectedQuantityForBatchSwap() }}
          <span class="text-warning ml-4"> Variance to Required Quantity (KG) : </span>{{ calculateVarianceQuantityForBatchSwap() }}
        </div>

        <vs-table :onlyClickCheckbox="true" :hoverFlat="true" :data="rm_swap_batch_list" class="mt-4">
          <template slot="thead">
            <vs-th width="20%">Batch Code</vs-th>
            <vs-th width="12%">FIFO Status</vs-th>
            <vs-th width="12%">RM Code</vs-th>
            <vs-th width="12%">EXP Date</vs-th>
            <vs-th width="14%">Available Quantity (KG)</vs-th>
            <vs-th width="15%">Selected Quantity (KG)</vs-th>
            <vs-th width="15%"></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].batch_no || data[indextr].code">
                {{ data[indextr].batch_no || data[indextr].code }}
              </vs-td>
              <vs-td>
                <vs-chip
                  v-if="data[indextr].is_opened"
                  color="warning"
                  class="font-semibold"
                  style="border-radius: 4px; font-size: 11px; height: 22px;">
                  Opened
                </vs-chip>
                <span v-else class="text-muted text-xs">
                  Unopened
                </span>
              </vs-td>
              <vs-td :data="data[indextr].company_product_code">
                <span v-if="data[indextr].category && data[indextr].company_product_code">
                  {{ data[indextr].category }}-{{ data[indextr].company_product_code }}
                </span>
                <span v-else>
                  {{ data[indextr].company_product_code || data[indextr].raw_material_code || data[indextr].code }}
                </span>
              </vs-td>
              <vs-td :data="data[indextr].expiration_date">
                {{ data[indextr].expiration_date }}
              </vs-td>
              <vs-td :data="data[indextr].available_quantity">
                {{ data[indextr].available_quantity }}
              </vs-td>
              <vs-td :data="data[indextr].available_quantity">
                <vs-input type="number" v-model="data[indextr].selected_quantity"></vs-input>
              </vs-td>
              <vs-td>
                <span v-if="Number(data[indextr].available_quantity) < Number(data[indextr].selected_quantity)" class="text-danger">
                  Not enough stock available for the selected quantity
                </span>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <div class="flex flex-wrap items-center justify-end mt-8">
          <vs-button
            v-if="calculateVarianceQuantityForBatchSwap() < 0.0001 && calculateVarianceQuantityForBatchSwap() >= 0 && !rm_swap_batch_list.some((x) => Number(x.available_quantity) < Number(x.selected_quantity))"
            @click="onClickSwap"
            color="primary"
            class="ml-auto mt-2">
            Confirm
          </vs-button>
        </div>
      </vx-card>
    </vs-popup>

  </vs-popup>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import {work_order_statuses} from '@/constants/statuses'
import {defaultPagination} from "@/constants/config";
import CreateWorkOrderWithSundryItemPopUp from "./CreateWorkOrderWithSundryItemPopUp";
import AddQcTestWorkOrderPopUp from "./qc-tests/AddQcTestWorkOrderPopUp";
import LabelPdfPopUp from "@/components/popups/manufacturing/work-order/Documents/LabelPdfPopUp";
import ManageWorkOrderCcpItemsPopup from "@/components/popups/manufacturing/work-order/ccp-items/ManageWorkOrderCcpItemsPopup.vue"
import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'

const ManufacturingRepository = RepositoryFactory.get('manufacturing')
const InventoryRepository = RepositoryFactory.get('inventory')
const TriangleTestsRepository = RepositoryFactory.get("triangle_tests");
const ScheduledTasksRepository = RepositoryFactory.get('scheduled_tasks');
const DropDownRepository = RepositoryFactory.get('drop_down')

import QrcodeVue from 'qrcode.vue'

function initialState() {
    return {
      open: false,
      openSundryItemPopUp: false,
      openUpdateSundryItemPopUp: false,
      openCcpItemPopup: false,
      openLabelPopup: false,
      openStatusChangeConfirm: false,
      openStartTankConfirm: false,
      openRmWasteItemReturn: false,
      wrong_item: {},
      rm_inventory_list: [],
      selected_rm_inventory: [],
      affected_rm_list: [],
      inventory_search_term: '',
      is_added_any_rm_by_mistake : false,
      labelData: {},
      createForm: {},
      types: ['liquid', 'powder', 'fruit'],
      id: null,
      orderDetails: {
        work_order_code: '',
        status: { name: '' },
        formulation: [],
        formulation_raw_material: [],
        formulation_formulation: [],
        formulation_spray_dry_carrier: [],
        reblended_stock: [],
        order_items: [],
        formulation_status: { name: '' },
        tasting_signoff: [],
        formulation_code: ''
      },
      productionCodes:[],
      item_switch: true,
      checkButton: true,
      statusActivePopup: false,
      status_change: {
        reason_for_change: '',
        supplier_id: null
      },
      logs: [],
      tasks: [],
      work_order_statuses: work_order_statuses,
      timer: 0,
      sundry_items_inventory: [],
      meta: {
        per_page: 10
      },
      pause_reasons: ['Hotplate', 'User break', 'User change', 'Problem with raw materials', 'problem with vessel or equipment', 'Other'],
      stop_reasons: ['User error - batch needs to be restarted', 'Raw material issue - product cant be used', 'Other '],
      qc_tests: [],
      actual_quantity_produces: '',
      ccp_items: [],
      selected_ccp_list: [],
      checked_item_list: [],
      searchText:'',
      page:1,
      perPage: defaultPagination,
      openCcpItemDescription: false,
      selected_ccp_description: '',
      qr_data: null,
      openAppQr: false,
      is_qr_show:false,
      is_wo_disabled: false,
      tastingFormList:[],
      activePromptSprayDryBtach: false,
      spray_dry_batches: [],
      selected_3rd_party_rm_payload: {},
      dispatchToSupplierActivePopup: false,
      supplier_list: [],
      activePromptSprayDryBtachUpdate: false,
      activeRmSwap: false,
      rm_swap_batch_list: [],
      selected_swap_rm_data: {}
    }
  }

export default {
  name: 'ViewWorkOrderPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.open = true;
        this.id = id
        // await this.getLiveProductionLineList()
        await this.getWorkOrderDetails()
      } catch (error) {

      }
    },
    async refreshData() {
      try {
        await this.getWorkOrderDetails()
      } catch (e) {

      }
    },
    printWorkOrder(){
      // document.body.innerHTML = document.getElementById('printSection').innerHTML;
      // window.print();
      // location.reload()
      let routeData = this.$router.resolve({name: 'work-order-print-view', params: {id:this.id }});
      window.open(routeData.href, '_blank');
    },
    async getWorkOrderDetails() {
      await this.$vs.loading();
      try {
        const {data} = (await ManufacturingRepository.getWorkOrder(this.id)).data;
        if(data.formulation_status.name !== "Production") {
          this.is_wo_disabled = true
        }
        this.orderDetails = data;
        this.orderDetails.order_items = data.order_items.map((n) => {
          n.pending_manufacture_quantity = Number(n.pending_manufacture_quantity)
          n.quantity = Number(n.quantity)
          n.max = Number(n.quantity) + Number(n.pending_manufacture_quantity)
          return n
        })
        if(this.orderDetails.formulation_formulation.length > 0) {
          this.orderDetails.formulation_raw_material = this.orderDetails.formulation_raw_material.concat(this.orderDetails.formulation_formulation)
        }
        if(this.orderDetails.formulation_type === 'spray dry powder') {
          let spray_dry_carriers = this.orderDetails.formulation_spray_dry_carrier
          spray_dry_carriers = spray_dry_carriers.map((sp) => {
            sp.location = !sp.location || sp.location.length === 0 ? [] : [ sp.location ]
            sp.assigned_raw_material = sp.assigned_spray_dry_carrier || sp.assigned_raw_material
            sp.is_3rd_party_rm = true
            return sp
          })
          this.orderDetails.formulation_raw_material = this.orderDetails.formulation_raw_material.concat(spray_dry_carriers)
        }
        this.orderDetails.formulation = this.orderDetails.formulation_raw_material.map((n) => {
          n.is_batch_confirmed = (n.location.length === 0 && n.assigned_raw_material.length > 0) || this.checked_item_list.includes(n.id);
          n.is_added_to_wip = n.location.length === 0 && n.assigned_raw_material.length > 0;
          return n;
        })
        this.orderDetails.reblended_stock = this.orderDetails.reblended_stock.map((n) => {
          n.is_batch_confirmed = n.status === 'Re_Blend_Complete' ? true : false;
          n.is_added_to_wip = n.status === 'Re_Blend_Complete' ? true : false;
          return n;
        })
        if(this.isInProgressStatus) {
          this.onChangeCheckBox()
        }
        if(this.isPackOffCompletedStatus || this.isPackOffInProgressStatus || this.isMixCompletedStatus){
          await this.getWorkOrderQcTest()
        }
        await this.getWorkOrderLog()
        // await this.getTasteFormList()
        await this.fetchTasks()
      } catch (e) {
      }
      this.$vs.loading.close()

    },
    async fetchTasks() {
      try {
        const response = await ScheduledTasksRepository.getListOfAllTaskInstances(`filter[reference_type]=Work Order&filter[reference_id]=${this.id}`);
        this.tasks = response.data.data;
      } catch (error) {}
    },
    onClickViewTask(task_id){
      let route = this.$router.resolve({path: `/pages/task-instance/${task_id}`});
      window.open(route.href, '_blank');
    },

    getSignoffStatus(tr) {
      const sigoff = this.orderDetails.tasting_signoff.find((item) => item.group_id === tr.id)
      if(sigoff) {
        return sigoff.status
      }
      return 'Pending'
    },

    onClickCreateTastePanel() {
      const route = this.$router.resolve({
        path: `/pages/taste-panels?create=${this.orderDetails.work_order_code}&type=work_order`,
      });

      window.open(route.href, "_blank");
    },

    onClickViewTastePanel(data) {
      const route = this.$router.resolve({
        path: `/pages/taste-panels?open=${data.id}`,
      });

      window.open(route.href, "_blank");
    },
    async getTasteFormList() {
      try {
        const response =
          await TriangleTestsRepository.getListOfQualityControlTestings(`filter[batch_id]=${this.id}&filter[batch_type]=${'Work Order'}`);
        this.tastingFormList = response.data.data;
      } catch (e) {}
    },
    async onClickViewTasteForm(id){
      let route = this.$router.resolve({path: `/pages/taste-panels?open=${id}`});
      window.open(route.href, '_blank');
    },
    async getWorkOrderLog() {
      this.$vs.loading()
      try {
        this.logs = (await ManufacturingRepository.workOrderLog(this.id)).data.data;
      } catch (error) {
        
      }
      this.$vs.loading.close()
    },
    searchSundryItems() {
      this.searchItems(this)
    },
    searchItems: _.debounce((vm) => {
      vm.getSundryInventory(vm.searchText)
    },1000),
    async onClickCreateProductionLine (){
      const vue = this
      await this.$vs.loading({
        container: '#create-production-line-popup',
        scale: 0.45
      })
       try {
         await ManufacturingRepository.createProductionLine(this.createForm)
         this.showSuccessMessage('Production line create successfully')
         this.open = false;
         await vue.$parent.refreshData()
         this.$vs.loading.close('#create-production-line-popup > .con-vs-loading')
       }catch (e) {
         this.$vs.loading.close('#create-production-line-popup > .con-vs-loading')
         this.convertAndNotifyError(e)
       }
    },

    // async getLiveProductionLineList() {
    //     this.$vs.loading()
    //     this.productionCodes = (await ManufacturingRepository.getLiveProductionLineList(1, 50)).data.data;
    //     this.$vs.loading.close()
    // },

    checkLocationQtyAndTotalQty(item_qty, locations) {
      const total_item_qty = Number(item_qty);
      const location_total = locations.reduce(function (acc, val) {
        return acc + Number(val.quantity);
      }, 0);
      return Number(total_item_qty) > Number(location_total)
    },

    async onClickAction(status, need_close = null) {
      if(['pause', 'stop'].includes(status)) {
        this.status_change.status = status
        this.status_change.reason_for_change = ''
        this.status_change.need_close = need_close
        this.status_change.remaining_time = ''

        if(status === 'stop') {
          this.openStatusChangeConfirm = true
        } else {
          this.statusActivePopup = true
        }
      } else if(status === 'disptach-to-supplier') {
        this.status_change.status = status
        this.status_change.supplier_id = null
        await this.fetchSupplierList()
        this.dispatchToSupplierActivePopup = true

      } else {
        this.status_change.status = status
        this.status_change.reason_for_change = ''
        this.status_change.remaining_time = ''
        this.status_change.need_close = need_close
        await this.changeStatus()
      }
    },
    async fetchSupplierList() {
      const { data } = await DropDownRepository.getApprovedSupplierList()
      this.supplier_list =  data.data
    },

    onClickStartConfirm() {
      this.openStartTankConfirm = true
    },
    proceedStart() {
      this.openStartTankConfirm = false
      this.onClickAction('start')
    },

    onClickStopConfirm() {
      this.openStatusChangeConfirm = false
      this.statusActivePopup = true
    },

    async changeStatus() {
      await this.$vs.loading();
      try {
        const payload = {
          reason_for_change: this.status_change.reason_for_change === 'Other' ?  this.status_change.reason : this.status_change.reason_for_change,
          remaining_time: '00:10',
          actual_end_time: moment().utc().format('HH:mm'),
          actual_end_date: moment().utc().format('DD/MM/YYYY'),
          actual_start_time: moment().utc().format('HH:mm'),
          actual_start_date: moment().utc().format('DD/MM/YYYY')
        }
        if(this.status_change.status === 'disptach-to-supplier') {
          payload.supplier_id = this.status_change.supplier_id
        }
        await ManufacturingRepository.workOrderStatusChange(this.orderDetails.id, this.status_change.status, payload)
        await this.getWorkOrderDetails()
        this.showSuccessMessage('Work order status changed successfully')
        if(this.status_change.need_close) {
          this.open = false
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.statusActivePopup = false
      this.dispatchToSupplierActivePopup = false
      await this.$vs.loading.close();
    },

    async onChangeCheckBox(item){
      // localStorage.setItem('work_order_items', [item.id])
      this.$forceUpdate();
      if(item && item.is_batch_confirmed) {
        if(!this.checked_item_list.includes(item.id)) {
          this.checked_item_list.push(item.id)
        }
      } else if (item) {
        this.checked_item_list = this.checked_item_list.filter((x) => x !== item.id)
      }
      const disabled = []
      const arr = this.orderDetails.formulation.concat(this.orderDetails.reblended_stock)
      arr.forEach((n) => {
        const hasError = n.reserved_batch_errors && n.reserved_batch_errors.length > 0
        disabled.push(n.is_batch_confirmed && n.is_added_to_wip && !hasError)
      })
      this.checkButton =  disabled.includes(false)
      if(item && item.is_batch_confirmed && item.is_added_to_wip) {
        let payload = {}
        if(item.company_product_code) {
          payload = {
            raw_material_id: item.id,
            batch_confirm: item.is_batch_confirmed,
            added_to_wip: item.is_added_to_wip,
            is_specific_batch_selected: false,
          }
        } else if(item.formulation_code) {
          payload = {
            formulation_id: item.id,
            batch_confirm: item.is_batch_confirmed,
            added_to_wip: item.is_added_to_wip,
            is_specific_batch_selected: false,
          }
        } 
        // else if(item.is_3rd_party_rm) {
        //   payload = {
        //     spray_dry_carrier_id: item.id,
        //     batch_confirm: item.is_batch_confirmed,
        //     added_to_wip: item.is_added_to_wip,
        //     is_specific_batch_selected: true,
        //     batch_numbers: [],
        //     quantity_kg: item.quantity_kg
        //   }
        // }
         else {
          payload = {
            reblend_id: item.id,
            batch_confirm: item.is_batch_confirmed,
            added_to_wip: item.is_added_to_wip,
            is_specific_batch_selected: false,
          }
        }
        if(item.is_3rd_party_rm) {
          this.spray_dry_batches = [ { number: '', quantity: item.quantity_kg } ]
          this.selected_3rd_party_rm_payload = payload
          this.activePromptSprayDryBtach = true
          return
        }
        await ManufacturingRepository.workOrderStatusChange(this.orderDetails.id, 'in_progress', payload)
        await this.getWorkOrderDetails()
      }
      if(item && item.is_3rd_party_rm && item.is_batch_confirmed) {
        this.spray_dry_batches = [ { number: '', quantity: 0 } ]
        this.selected_3rd_party_rm_payload = {
            spray_dry_carrier_id: item.id,
            batch_confirm: item.is_batch_confirmed,
            added_to_wip: item.is_added_to_wip,
            is_specific_batch_selected: true,
            batch_numbers: [],
            quantity_kg: item.quantity_kg
        }
        this.selected_3rd_party_rm_payload.quantity_kg = item.quantity_kg
        this.activePromptSprayDryBtach = true
        return
      }
    },

    async add3rdPartyRm() {
      try {
        if(this.spray_dry_batches.length === 0) {
          await this.cancel3rdPartyRmBatchPrompt()
          return
        }
        // const totalBatchQty = this.spray_dry_batches.reduce((sum, item) => {
        //   return sum + Number(item.quantity || 0)
        // }, 0)
        // const selectedQty = Number(this.selected_3rd_party_rm_payload.quantity_kg)
        // if (totalBatchQty.toFixed(4) !== selectedQty.toFixed(4)) {
        //   alert('Total spray dry batch quantity must equal RM quantity')
        //   await this.cancel3rdPartyRmBatchPrompt()
        //   return
        // }

        this.selected_3rd_party_rm_payload.batch_numbers = this.spray_dry_batches.map((item) => {
          if(item.number && item.quantity){
            return { number: item.number, quantity: Number(item.quantity).toFixed(4)}
          }
        })
        this.selected_3rd_party_rm_payload.added_to_wip = true
        await ManufacturingRepository.workOrderStatusChange(this.orderDetails.id, 'in_progress', this.selected_3rd_party_rm_payload)
        this.activePromptSprayDryBtach = false
        this.selected_3rd_party_rm_payload = {}
        await this.getWorkOrderDetails()
      } catch (error) {
        this.convertAndNotifyError(error)
        await this.cancel3rdPartyRmBatchPrompt()
      }
    },
    async cancel3rdPartyRmBatchPrompt() {
      try {
        this.checked_item_list = this.checked_item_list.filter(x => x !== this.selected_3rd_party_rm_payload.spray_dry_carrier_id)
        this.orderDetails.formulation = this.orderDetails.formulation.map((x) => {
          if(x.id === this.selected_3rd_party_rm_payload.spray_dry_carrier_id) {
            x.is_added_to_wip = false
            x.is_batch_confirmed = false
          }
          return x
        })
        this.$forceUpdate();
      } catch (error) {
        
      }
    },

    async onClickClose() {
      if(this.isInProgressStatus) {
        this.open = true
        await this.onClickAction('pause', true)
      } else {
        this.$emit('refreshData', '')
        this.open = false
      }
    },

    getStatusName(id) {
      const find = this.work_order_statuses.find((n) => {
        return n.id === id
      })
      return find ? find.name : 'N/A'
    },

    async onClickSundryItemAdd() {
      await this.$vs.loading({
        container: '#sundry-item-list-table',
        scale: 0.45
      })
      try {
        const { data } = (await ManufacturingRepository.fetchApplicableCcpItems(this.id)).data
        this.ccp_items = data
        if(this.orderDetails.ccp_items.length !== this.ccp_items.length) {
          // this.openCcpItemPopup = true
          await this.onClickAddCcpItems()
        } else if(!this.isPackOffInProgressStatus) {
          await this.onClickAction('start_pack_off')
          this.openSundryItemPopUp = true
          await this.getSundryInventory()
        } else if(this.isPackOffInProgressStatus) {
          this.openSundryItemPopUp = true
          await this.getSundryInventory()
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#sundry-item-list-table > .con-vs-loading')
    },

    async onCLickStartCleanDown() {
      await this.$vs.loading();
      try {
        const payload = {
          actual_start_clean_time: moment().utc().format('HH:mm')
        }
        await ManufacturingRepository.workOrderStartCleanDown(this.orderDetails.id, payload)
        await this.getWorkOrderDetails()
        this.showSuccessMessage('Work order status changed successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close();
    },

    async onCLickEndCleanDown() {
      await this.$vs.loading();
      try {
        const payload = {
          actual_end_clean_time: moment().utc().format('HH:mm')
        }
        await ManufacturingRepository.workOrderEndCleanDown(this.orderDetails.id, payload)
        await this.getWorkOrderDetails()
        this.showSuccessMessage('Work order status changed successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close();
    },

    async onClickUpdateSundryItems() {
      await this.getSundryInventory()
      this.openUpdateSundryItemPopUp = true
      // this.orderDetails.sundry_items.forEach((n) => {
      //   this.sundry_items_inventory.forEach((m) => {
      //         if(n.id === m.id) {
      //           m.quantity = n.quantity
      //         }
      //         return m
      //     })
      // })
    },

    async getSundryInventory(search = null) {
      try {
        const query = search != null ? ManufacturingRepository.getSundryInventory(this.page, 150, `filter[search]=${this.searchText}`, 'created_at') :
        ManufacturingRepository.getSundryInventory(1, 150, '', 'created_at')
        const { data } = (await query ).data
        const already_added_ids = this.orderDetails.sundry_items.map((n) => n.id)
        this.sundry_items_inventory = data
          .filter(
            n =>
              n.status === 'In_Stock' ||
              already_added_ids.includes(n.id)
          )
          .map(item => {
            const existing = this.orderDetails.sundry_items.find(
              n => n.id === item.id
            )

            if (existing) {
              item.quantity = existing.quantity
              item.max =
                Number(existing.quantity) +
                Number(item.available_quantity)
            } else {
              item.max = Number(item.available_quantity)
            }

            return item
          })
      } catch (error) {
        
      }
    },

    async addSundryItem() {
      await this.$vs.loading();
      try {
        const arr = []
        this.sundry_items_inventory.forEach((n) => {
          if(Number(n.quantity) > 0) {
            arr.push({id: n.id, quantity: n.quantity})
          }
        })
        const payload = {
          work_order_id: this.id,
          sundry_stock_inventory_items: arr
        }
        await ManufacturingRepository.createWorkOrderWithSundryItem(payload)
        await this.getWorkOrderDetails()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.openSundryItemPopUp = false
      await this.$vs.loading.close();
    },

    async updateSundryItem() {
      await this.$vs.loading();
      try {
        const arr = []
        this.sundry_items_inventory.forEach((n) => {
          if(Number(n.quantity) > 0) {
            arr.push({id: n.id, quantity: n.quantity})
          }
        })
        const payload = {
          sundry_stock_inventory_items: arr
        }
        await ManufacturingRepository.updateWorkOrderWithSundryItem(this.id, payload)
        await this.getWorkOrderDetails()
      } catch (e) {

        this.convertAndNotifyError(e)
      }
      this.openUpdateSundryItemPopUp = false
      await this.$vs.loading.close();
    },

    async getWorkOrderQcTest() {
      const {data} = (await ManufacturingRepository.getWorkOrderQcTest(this.id)).data;
      this.qc_tests= data
    },

    onClickCreateQcTest(method, data = {}) {
      this.$refs.addQcTestWorkOrderPopUp.openPopup(this.id, this.orderDetails.formulation_type, method, data, this.orderDetails.formulation_id)
    },

    async onClickAddCcpItems() {
      await this.$refs.ManageWorkOrderCcpItemsPopup.openPopup(this.id, this.orderDetails.work_order_code, this.orderDetails.formulation_type, this.isPackOffCompletedStatus)

      // const { data } = (await CcpRepository.getListOfCcpNoPagination(
      //   `filter[type]=${this.orderDetails.formulation_type === 'liquid' ? 'liquid' : 'powder'}`
      // )).data
      // this.ccp_items = data
      // this.selected_ccp_list = []
      // this.orderDetails.ccp_items.forEach((n) => {
      //   let find = this.ccp_items.find((m) => m.name === n.name)
      //   find.comment = n.comment ? n.comment : ''
      //   this.selected_ccp_list.push(find)
      // })
      // this.openCcpItemPopup = true
    },

    async onClickAddCcpItem() {
      await this.$vs.loading();
      try {
        const payload = {
          ccp_items: this.selected_ccp_list.map((n) => { return { name: n.name, comment: n.comment } })
        }
        await ManufacturingRepository.updateWorkOrderWithCcpItem(this.id, payload)
        await this.getWorkOrderDetails()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.openCcpItemPopup = false
      await this.$vs.loading.close();
    },
    openCcpDescriptionPopup(des) {
      this.selected_ccp_description = des
      this.openCcpItemDescription = true
    },

    async onClickCcpRowAdd() {
      this.orderDetails.ccp_items.push('')
    },

    onClickViewLabel(data) {
      let routeData = this.$router.resolve({name: 'work-order-label-print-view', params: {id:this.id }, 
        query: {
          so_id: data.product_order ? data.product_order.id : (data.order_id || null), 
          stock_id: data.product_order ? data.id : null
        }
      });
      window.open(routeData.href, '_blank');
    },

    onClickWrongItem(item) {
      this.rm_inventory_list = []
      this.selected_rm_inventory = []
      this.affected_rm_list = []
      this.is_added_any_rm_by_mistake = false
      this.openRmWasteItemReturn = true
      this.inventory_search_term = ''
      this.wrong_item = item
    },

    async onInputRmInventorySeach() {
      this.searchInventory(this.inventory_search_term, this)
    },
    async onInputWorkOrderDetails() {
      this.updateWorkOrderData({ pack_size: Number(this.orderDetails.pack_size).toFixed(4) }, this)
    },
    async handleSelectedWrongRm(tr) {
      const payload = this.selected_rm_inventory.map((n) => {
        return { raw_material_id: n.rm_id, quantity: Number(n.quantity).toFixed(4) }
      })
      const { data }  = (await ManufacturingRepository.checkAutoCancellation({ rm_stock_items: payload })).data
      this.affected_rm_list = data
    },
    searchInventory: _.debounce( async (search, vm) => {
      const {data} = await ManufacturingRepository.getRawMaterialStock(1, `filter[search]=${search}&filter[status]=In_Stock`, 50)
      vm.rm_inventory_list = data.data.map((n) => { n.quantity = Number(n.available_quantity).toFixed(4); return n; })
    }, 350),
    updateWorkOrderData: _.debounce(async (data, vm) => {
      await ManufacturingRepository.updateWorkOrderDetails(vm.id, data)
      vm.showSuccessMessage('Work order details updated successfully')
    }, 350),
    async onInventoryWasteInputValidate(index) {
      await this.handleSelectedWrongRm()
      const inventory = this.selected_rm_inventory[index]
      if(Number(inventory.available_quantity) < Number(inventory.quantity)) {
        this.selected_rm_inventory[index].quantity = Number(inventory.available_quantity).toFixed(4)
      }
    },
    async onCLickReturnToInventory() {
      await this.$vs.loading();
      try {
        const rm = this.wrong_item.category+'-'+this.wrong_item.company_product_code
        const { data } = (await InventoryRepository.getRmWasteItem(this.orderDetails.work_order_code, rm)).data
        if(data.length !== 0) {
          const rm_waste_id = data.map((n) => n.id);
          const payload = {rm_waste_ids: rm_waste_id}
          await InventoryRepository.removeRawMaterialWaste(payload)

          if(this.is_added_any_rm_by_mistake) {
            const payload = {
              work_order_id: this.orderDetails.id,
              formulation_id: this.orderDetails.formulation_id,
              rm_stock_batches: this.selected_rm_inventory.map((n) => {
                return { raw_material_stock_inventory_id: n.id, quantity: Number(n.quantity).toFixed(4) };
              }),
              is_cancel_work_orders: this.affected_rm_list.length !== 0,
              cancel_work_order_ids: this.affected_rm_list.map((n) => n.id)
            }
            await InventoryRepository.createRawMaterialWaste(payload)
          }

          await this.getWorkOrderDetails()
          this.showSuccessMessage('RM item returned to inventory')
        } else {
          this.showErrorMessage('Already returned to the inventory')
        }
        this.openRmWasteItemReturn = false
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close();
    },
    isDisabledWrongItemButton(category, code) {
      const its_prod_code = category+'-'+code
      const find = this.orderDetails.created_rm_waste_items.find((n) => n.raw_material === its_prod_code)
      return !find
    },
    async fetchQrData() {
      try {
        if(!this.qr_data) {
          const { data } = (await ManufacturingRepository.getWorkOrderQrData(this.id)).data
          this.qr_data = JSON.stringify(data)
        }
        // this.openAppQr = true
        this.is_qr_show = !this.is_qr_show 
      } catch (error) {
        
      }
    },
    onClickUpdate3rdPartyRmBatchDetails(item) {
      this.selected_3rd_party_rm_payload = item
      this.spray_dry_batches = item.assigned_spray_dry_carrier.map((batch) => {
        return { number: batch.batch_no, quantity: batch.quantity }
      })
      this.activePromptSprayDryBtachUpdate = true
    },
    async update3rdPartyRmBatchDetails() {
     try {
      let payload = {
        spray_dry_carrier_id: this.selected_3rd_party_rm_payload.id,
        batch_numbers: this.spray_dry_batches.map(batch => ({number: batch.number, quantity: Number(batch.quantity).toFixed(4)}))
      }
        await ManufacturingRepository.update3rdPartyRmBatchDetails(this.id, payload)
        await this.getWorkOrderDetails()
        this.activePromptSprayDryBtachUpdate = false
     } catch (error) {
      this.convertAndNotifyError(error)
     } 
    },
    async onClickSwapRmBatch(arg1, arg2, arg3, arg4) {
      const item = (arg2 && typeof arg2 === 'object') ? arg2 : arg1
      const item_index = (arg2 && typeof arg2 === 'object') ? arg3 : arg2
      const location = (arg2 && typeof arg2 === 'object') ? arg1 : null
      const location_index = (arg2 && typeof arg2 === 'object') ? arg4 : null

      await this.$vs.loading()
      try {
        const searchCode = item.category && item.company_product_code
          ? `${item.category}-${item.company_product_code}`
          : (item.company_product_code || item.code || '')
        const { data } = await ManufacturingRepository.getRawMaterialStock(1, `filter[search]=${searchCode}&filter[status]=In_Stock`, 150, '')

        const rawBatches = (data.data || []).filter((x) => {
          const isStatusOk = x.status === 'In-Stock' || x.status === 'In_Stock'
          const isCategoryOk = !item.category || !x.category || x.category === item.category
          return isStatusOk && isCategoryOk
        })

        const batches = rawBatches.map((x) => {
          let selected_qty = 0
          if (item.location && Array.isArray(item.location)) {
            const found = item.location.find(loc => Number(loc.id) === Number(x.id))
            if (found && (found.quantity || found.quantity === 0)) {
              selected_qty = found.quantity
            }
          }
          return {
            ...x,
            selected_quantity: selected_qty
          }
        })

        batches.sort((a, b) => {
          const aOpened = !!a.is_opened
          const bOpened = !!b.is_opened
          if (aOpened && !bOpened) return -1
          if (!aOpened && bOpened) return 1
          const aDate = a.manufacture_date || a.expiration_date || ''
          const bDate = b.manufacture_date || b.expiration_date || ''
          return aDate.localeCompare(bDate)
        })

        this.rm_swap_batch_list = batches

        this.selected_swap_rm_data = {
          location,
          item,
          item_index,
          location_index
        }

        this.activeRmSwap = true
      } catch (error) {
        this.convertAndNotifyError(error)
      } finally {
        await this.$vs.loading.close()
      }
    },

    onClickSwap() {
      const hasAvailableOpenedBatch = this.rm_swap_batch_list.some(
        b => b.is_opened &&
             (Number(b.available_quantity) > Number(b.selected_quantity || 0))
      )
      const selectedUnopenedBatch = this.rm_swap_batch_list.some(
        b => !b.is_opened &&
             Number(b.selected_quantity || 0) > 0
      )

      if (hasAvailableOpenedBatch && selectedUnopenedBatch) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'FIFO Override Notice',
          text: 'There is an opened/started batch available that must be used first according to FIFO rules. Are you sure you want to override and allocate this batch for this Work Order?',
          acceptText: 'Confirm Override',
          cancelText: 'Cancel',
          accept: () => {
            this.executeSwap()
          }
        })
      } else {
        this.executeSwap()
      }
    },

    async executeSwap() {
      await this.$vs.loading()
      try {
        const { item } = this.selected_swap_rm_data
        const selectedBatches = this.rm_swap_batch_list.filter(x => Number(x.selected_quantity) > 0)

        const payload = {
          raw_material_id: item.id,
          batches: selectedBatches.map(batch => ({
            id: batch.id,
            quantity: Number(batch.selected_quantity).toFixed(4)
          }))
        }

        await ManufacturingRepository.updateWorkOrderReservedBatches(this.id, payload)
        this.showSuccessMessage('Reserved batches updated successfully')
        this.activeRmSwap = false
        await this.getWorkOrderDetails()
      } catch (error) {
        this.convertAndNotifyError(error)
      } finally {
        await this.$vs.loading.close()
      }
    },

    onClickRevertRmBatch(item) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Revert Reserved Batches',
        text: `Are you sure you want to revert swapped batches for ${item.company_product_name || item.name || 'this item'} back to default allocated batches?`,
        acceptText: 'Revert Batches',
        cancelText: 'Cancel',
        accept: async () => {
          await this.$vs.loading()
          try {
            await ManufacturingRepository.deleteWorkOrderReservedBatches(this.id, {
              raw_material_id: item.id
            })
            this.showSuccessMessage('Reserved batches reverted successfully')
            await this.getWorkOrderDetails()
          } catch (error) {
            this.convertAndNotifyError(error)
          } finally {
            await this.$vs.loading.close()
          }
        }
      })
    },

    calculateRequiredQuantityForBatchSwap() {
      if (this.selected_swap_rm_data && this.selected_swap_rm_data.item && (this.selected_swap_rm_data.item.quantity_kg || this.selected_swap_rm_data.item.quantity_kg === 0)) {
        return Number(this.selected_swap_rm_data.item.quantity_kg).toFixed(4)
      }
      return '0.0000'
    },

    calculateSelectedQuantityForBatchSwap() {
      return Number(this.rm_swap_batch_list.reduce((a, b) => a + Number(b.selected_quantity || 0), 0)).toFixed(4)
    },

    calculateVarianceQuantityForBatchSwap() {
      const required = Number(this.calculateRequiredQuantityForBatchSwap())
      const selected = Number(this.calculateSelectedQuantityForBatchSwap())
      return Number(required - selected).toFixed(4)
    }
  },
  computed: {
    isConfirmedStatus(){
      return this.orderDetails.status && this.orderDetails.status.name === 'Confirmed'
    },
    isInOpenStatus(){
      return this.orderDetails.status && this.orderDetails.status.name === 'Open'
    },
    isCancelledStatus(){
      return this.orderDetails.status && this.orderDetails.status.name === 'Cancelled'
    },
    isInProgressStatus(){
      return this.orderDetails.status && this.orderDetails.status.name === 'In Progress'
    },
    isPausedStatus(){
      return this.orderDetails.status && this.orderDetails.status.name === 'Paused'
    },
    isStoppedStatus(){
      return this.orderDetails.status && this.orderDetails.status.name === 'Stopped'
    },
    isMixCompletedStatus(){
      return this.orderDetails.status && this.orderDetails.status.name === 'Mix Completed'
    },
    isPackOffInProgressStatus(){
      return this.orderDetails.status && this.orderDetails.status.name === 'Pack Off In Progress'
    },
    isPackOffCompletedStatus(){
      return this.orderDetails.status && this.orderDetails.status.name === 'Pack Off Completed'
    },
    isNotSubmittedToQc() {
      return this.orderDetails.q_c_status === 'Not Submitted to QC'
    },
    isSubmittedToQc() {
      return this.orderDetails.q_c_status === 'Submitted to QC'
    },
    isSampleTakenByQc() {
      return this.orderDetails.q_c_status === 'Sample Taken By QC'
    },
    isDilCodedFormulation() {
      return !!(this.orderDetails.formulation_code && this.orderDetails.formulation_code.includes('DIL-'))
    },
    plannedCleanDownEndTime() {
      const clean_time = moment.duration(this.orderDetails.formulation_clean_time, 'HH:mm').asMinutes()
      return moment(this.orderDetails.end_time, "HH:mm").add(clean_time, 'minutes').format('HH:mm')
    },
    totalQuantity() {
      if(!this.orderDetails.order_items || this.orderDetails.order_items.length === 0) {
        return Number(( Number(this.orderDetails.unallocated_amount || 0) * (this.orderDetails.variance || 0) ) / 100).toFixed(3)
      }
      const total = this.orderDetails.order_items.reduce((acc, obj) => {
        return acc + Number(obj.quantity || 0)
      }, 0)
      return Number(( total * (this.orderDetails.variance || 0) ) / 100).toFixed(3)
    },
    isSmallerScreen () {
      return this.$store.state.windowWidth + '*' + this.$store.state.windowHeight
    },
    isSprayDryProduct() {
      return this.orderDetails.formulation_type === 'spray dry powder'
    },
    isDispatchToSupplierStatus(){
      return this.orderDetails.status && this.orderDetails.status.name === 'Dispatched to Supplier'
    },
    allItemsAddedExceptCarriers() {
      const items = (this.orderDetails.formulation || []).filter((x) => !x.is_3rd_party_rm)
      return items.length > 0 && items.every(x => x.is_batch_confirmed && x.is_added_to_wip)
    },
    isTastePanelApproved() {
      return Array.isArray(this.orderDetails.tasting_signoff) && this.orderDetails.tasting_signoff.some((x) => x.status === 'Passed')
    },
    isReturnedFromSupplierStatus() {
      return this.orderDetails.status && this.orderDetails.status.name === 'Returned from Supplier'
    }
  },
  watch: {
    orderDetails: {
      handler(newValue, oldValue) {

      },
      deep: true
    },
  },
  components: {
    AddQcTestWorkOrderPopUp,
    'v-select': vSelect,
    flatPickr,
    CreateWorkOrderWithSundryItemPopUp,
    LabelPdfPopUp,
    QrcodeVue,
    ManageWorkOrderCcpItemsPopup
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .view-work-order-popup >>> .vs-popup {
    min-height: 90% !important;
    min-width: 90% !important;
  }
  .rm-wrong-item-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 70% !important;
  }
  .app-qr-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    /* min-width: 30% !important; */
  }
  .label-popup >>> .vs-popup {
    min-height: 50% !important;
    min-width: 50% !important;
  }
  .sundry-item-list-table >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 80% !important;
  }
  .add-ccp-items-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 60% !important;
  }
  .rm-batch-swap >>> .vs-popup {
    min-width: 60% !important;
  }
  .item-list {
    width: 100%;
    background: #fff;
    border-radius: .5rem;
    box-shadow: 0px 4px 25px 0px rgba(0,0,0,.1);
    position: relative;
    transition: all .3s ease-in-out;
  }
  .item-list-danger {
    width: 100%;
    background: #fff;
    border-radius: .5rem;
    box-shadow: 0px 0px 5px 5px rgba(255, 0, 0, 0.5);
    position: relative;
    transition: all .3s ease-in-out;
  }
  .item-list-success {
    width: 100%;
    background: #fff;
    border-radius: .5rem;
    box-shadow: 0px 0px 5px 5px rgba(0, 200, 0, 0.5);
    position: relative;
    transition: all .3s ease-in-out;
  }
  .checkbox-custom{
    content: '';
    top: 0;
    width: 5em;
    height: 5em;
    margin: 0;
    border:none;
  }
  @media print {
    @page  {
      size: A4 portrait;
    }
    .hiddenSection {
      visibility: hidden !important;
    }

    #printSection {
      width: 100% !important;
      position: relative;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.disabled a {
  color: #888;
}

.batch-details-enter-prompt >>> .vs-dialog {
    /* min-height: 90% !important; */
    min-width: 40% !important;
  }

</style>
